/**
 *
 * AdministratorBCView sagas
 *
 */

import {call, put, takeLatest} from 'redux-saga/effects';
import {push} from "react-router-redux";
import * as api from 'utils/api';
import {openViewDialog} from 'containers/AdvancedFormDialog/actions';
import {changeEntitiesState} from 'domain/Data/actions';
import {HANDLE_PARAMS_ACTION, TENANT_RULE_FORM_DIALOG} from './constants';
import {CLOSE_DIALOG} from "containers/AdvancedFormDialog/constants";


const goDefaultView = (action) => action.type === CLOSE_DIALOG && action.meta.dialog === TENANT_RULE_FORM_DIALOG;
export default function createTenantViewSaga() {
    return function* rootSaga() {
        yield takeLatest(HANDLE_PARAMS_ACTION, handleParamsSaga);
        yield takeLatest(goDefaultView, executeGoDefaultViewSaga);
    };
}

function* executeGoDefaultViewSaga() {
    yield put(push(''))
}

function* handleParamsSaga({payload: {id}}) {
    const response = yield call(api.load, 'documents', id);
    const rule = response.data;
    if (!rule) {
        return;
    }
    yield put(changeEntitiesState('documents', [rule]));
    yield put(openViewDialog(TENANT_RULE_FORM_DIALOG, {id}));
}
